import { render, staticRenderFns } from "./glzd.vue?vue&type=template&id=450e3984&scoped=true"
import script from "./glzd.vue?vue&type=script&lang=js"
export * from "./glzd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e3984",
  null
  
)

export default component.exports